var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"x-small":"","fab":"","color":_vm.getLogColor(_vm.item.incidents_status),"elevation":"0","to":{
    name: 'incidents',
    params: {
      project_id: _vm.item.id
    }
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }